import angular from 'angular';
import constants from 'app/constants';
import {
  praDataService,
  loaderService,
  ssDialogService,
  praSharedModelService,
  assetSharedModelService
} from 'app/services';
import {
  alerts
} from 'app/components/global';

import approvePraProcess from '../approveProcess';
import controller from './approve-pra-process-dialog.controller';
import template from './approve-pra-process-dialog.html';


class dialogService {
  getOptions($event, {
    _processes, activeProcess,
  }) {
    return {
      controller,
      controllerAs: 'approvePRAProcessDialogVM',
      locals: {
        _processes,
        activeProcess,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pra.approvePRAProcessDialog', [
  alerts,
  praDataService,
  constants,
  loaderService,
  approvePraProcess,
  ssDialogService,
  praSharedModelService,
  assetSharedModelService
])
  .service('approvePRAProcessDialog', dialogService)
  .name;
